<template>
  <LandingPage
    :page="page"
    :isNotFound="isNotFound"
    :shareUrl="shareUrl"
    :taglineFallback="`At ${venue_name}`"
    loadingText="Loading..."
  />
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { toRefs } from 'vue'

import LandingPage from '@/modules/guestUi/components/templates/LandingPage.vue'
import { useLandingPage } from '@/modules/guestUi/composables/useLandingPage'
import { buildEventsJsonLd, buildPageUrl } from '@/modules/residency/utils/seo'
import { useCheckoutStore } from '@/stores/checkout'
import { useSettingStore } from '@/stores/setting'
import { buildShowRichPagePath } from '@/utils/showRichPagePath'

const props = defineProps<{ slug: string }>()
const { slug } = toRefs(props)

const checkoutStore = useCheckoutStore()
const settingStore = useSettingStore()
const { venue_name } = storeToRefs(settingStore)

const { page, isNotFound, shareUrl } = useLandingPage({
  fetchPage: () => checkoutStore.getShowRichPage(slug.value),
  buildPagePath: buildShowRichPagePath,
  buildJsonLd: richPage =>
    buildEventsJsonLd(
      richPage,
      settingStore,
      buildPageUrl(settingStore.canonicalDomain, buildShowRichPagePath(richPage.slug)),
    ),
  pageVersion: { key: 'show_page_version', version: 'rich' },
})
</script>
